'use client'

import { useAxios } from "@/hooks";
import { setCartData } from "@/redux/actions/user.action";
import { AppDispatch } from "@/redux/store";
import { endPoint } from "@/utils";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

interface TProps {
    eventId: string;
    cartData: any;
    onNext: () => void;
}

const useDateTime = ({ eventId, cartData, onNext }: TProps) => {
    const [dates, setDates] = useState([]);
    const [times, setTimes] = useState([]);

    const { fetchData, loading } = useAxios();

    const dispatch = useDispatch<AppDispatch>();

    const handleSelectDate = async (date: any) => {
        if (!date?.date) return;        

        if (date?.hasTime) {
            dispatch(setCartData(date, {}, {}));
            await fetchEventTimes(date?.date);
        } else {
            dispatch(setCartData(date, {}, {}));
            await fetchEventTimes(date?.date);
            onNext();
        }
    }

    const handleSelectTime = (time: any) => {
        if (!time) return;

        dispatch(setCartData(cartData?.selectedDate, time, {}));

        onNext();
    }

    const fetchEventDates = async () => {
        try {
            if (eventId) {
                dispatch(setCartData({}, {}, {}));
                const res: any = await fetchData({
                    url: endPoint.FETCH_ACTIVE_DATES,
                    method: 'GET',
                    params: { eventId },
                });

                const today = new Date().setHours(0, 0, 0, 0);
                const dates = res?.data?.dates?.filter((date: any) => {
                    return date?.date >= today;
                });

                setDates(dates);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const fetchEventTimes = async (date: number) => {
        try {
            if (eventId) {
                const res: any = await fetchData({
                    url: endPoint.FETCH_ACTIVE_SLOTS,
                    method: 'GET',
                    params: { eventId, date },
                    loading: false,
                });

                setTimes(res?.data?.slots);
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        fetchEventDates();
    }, []);

    return {
        loading,
        dates,
        times,
        handleSelectDate,
        handleSelectTime,
    }
}

export default useDateTime;